"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAction = void 0;
var ChainAction;
(function (ChainAction) {
    ChainAction["GET_TRANSACTION_STATUS"] = "GET_TRANSACTION_STATUS";
    ChainAction["GET_CHAIN_NODES"] = "GET_CHAIN_NODES";
    ChainAction["GET_BLOCK_HASH"] = "GET_BLOCK_HASH";
    ChainAction["GET_BLOCK"] = "GET_BLOCK";
    ChainAction["GET_BLOCK_INFO"] = "GET_BLOCK_INFO";
    ChainAction["GET_WALLET"] = "GET_WALLET";
    ChainAction["GET_NODE_SETTINGS"] = "GET_NODE_SETTINGS";
    ChainAction["CREATE_TRANSACTION"] = "CREATE_TRANSACTION";
    ChainAction["GET_MY_CHAIN"] = "GET_MY_CHAIN";
    ChainAction["GET_SC_CODE"] = "GET_SC_CODE";
    ChainAction["GET_SC_STATE"] = "GET_SC_STATE";
    ChainAction["GET_SC_STATE_BY_KEY"] = "GET_SC_STATE_BY_KEY";
    ChainAction["GET_LSTORE"] = "GET_LSTORE";
})(ChainAction = exports.ChainAction || (exports.ChainAction = {}));
